













import mixins from 'vue-typed-mixins';
import UserAgreementForm from '@/components/user/UserAgreementForm.vue';
import UserAgreementUtils, { UserAgreement } from '@/utils/UserAgreementUtils';
export default mixins().extend({
  components: {
    UserAgreementForm,
  },

  data(): {
    item?: Partial<UserAgreement>;
  } {
    return {
      item: {
        id: undefined,
        name: undefined,
        text: this.$languageobj(),
        checkboxlabel: this.$languageobj(),
        active: false,
      },
    };
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await UserAgreementUtils.api.add(this.item);
          await this.$router.push({ name: 'useragreement' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
